// extracted by mini-css-extract-plugin
export default {"container":"aA6zH","seatInfo":"P5m9I","ticketInfo":"bwdif","ticketPrice":"_4LubD"};